<template>
  <div class="columns h-100 background-image d-flex flex-grow-1">
    <div class="column is-8-tablet is-offset-2-tablet is-6-desktop is-offset-3-desktop is-4-fullhd is-offset-4-fullhd">
    <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthContainer',
}
</script>

<style lang="scss" scoped>
.background-image {
  background-image: url('./images/login-background.png');
  background-size: 200px 200px;
}
</style>



// WEBPACK FOOTER //
// AuthContainer.vue?a947f5de